import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import "./AdminInformation.css";
import {Link} from "react-router-dom";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../configuration";

class AdminInformation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            role: "",
            address: "",
            japaneseFirstName: "",
            japaneseLastName: "",
            gender: "",
            phone: "",
            status : "",
            username : "",
            jpFname : "",
            jpLname : ""
        };

    }

    componentDidMount() {
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.match.params.id)
            .then((res) => {
                // console.log("ADMIN USER INFO====>",res.data);
                this.setState({
                    name: res.data.name,
                    email: res.data.email,
                    role: res.data.userRole,
                    address: res.data.primaryAddress,
                    japaneseFirstName: res.data.japaneseFirstName,
                    japaneseLastName: res.data.japaneseLastName,
                    gender: res.data.gender,
                    phone: res.data.phone,
                    username : res.data.username,
                    status : res.data.status,
                    jpFname : res.data.japaneseFirstName,
                    jpLname : res.data.japaneseLastName
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }

    render() {
        return (
            <div className="user-update-content">
                <div className="user-update-div">
                    <form>
                        <div className="title-1 text-align-left">
                            <FormattedMessage id="app.admin-info.title"
                                              defaultMessage="VIEW ADMIN USER"
                                              description=""/>
                        </div>
                        <hr/>
                        {/*<div className="row">*/}
                            {/*<div className="user-update-row-margin">*/}
                                {/*<div className="col-md-2  custom-col-4">*/}
                                    {/*<div className="text-right resp-user-info">*/}
                                        {/*<label>*/}
                                            {/*/!*<FormattedMessage id="app.admin-info.name"*!/*/}
                                                              {/*/!*defaultMessage="Name"*!/*/}
                                                              {/*/!*description=""/>*!/*/}
                                            {/*アカウント名*/}
                                        {/*</label>*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                                {/*<div className="col-md-10   custom-col-8 no-padding-left">*/}
                                    {/*{this.state.name}*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2  custom-col-4">
                                    <div className="text-right">
                                        <label>
                                            {/*<FormattedMessage id="app.admin-info.jpFname"*/}
                                            {/*defaultMessage="Japanese First Name"*/}
                                            {/*description=""/>*/}
                                            姓
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-4 custom-col-4 no-padding-left ">
                                    {this.state.jpFname}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2  custom-col-4">
                                    <div className="text-right">
                                        <label>
                                            {/*<FormattedMessage id="app.admin-info.jpLname"*/}
                                            {/*defaultMessage="Japanese Last Name"*/}
                                            {/*description=""/>*/}
                                            名
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-4 custom-col-4 no-padding-left ">
                                    {this.state.jpLname}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2  custom-col-4">
                                    <div className="text-right resp-user-info">
                                        <label>
                                            <FormattedMessage id="app.admin-info.email"
                                                              defaultMessage="Email"
                                                              description=""/>

                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10  custom-col-8 no-padding-left">
                                    {this.state.email}
                                </div>
                            </div>
                        </div>

                        {/*<div className="row">*/}
                            {/*<div className="user-creation-row-margin">*/}
                                {/*<div className="col-md-2">*/}
                                    {/*<div className="text-right">*/}
                                        {/*<label>*/}
                                            {/*<FormattedMessage id="app.admin-info.address"*/}
                                                              {/*defaultMessage="Address"*/}
                                                              {/*description=""/>*/}

                                        {/*</label>*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                                {/*<div className="col-md-10 no-padding-left">*/}
                                    {/*{this.state.address}*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        <div className="row">
                            <div className="user-creation-row-margin">
                                <div className="col-md-2  custom-col-4">
                                    <div className="text-right resp-user-info">
                                        <label>
                                            <FormattedMessage id="app.admin-info.phone"
                                                              defaultMessage="Phone"
                                                              description=""/>

                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10  custom-col-8 no-padding-left">
                                    {this.state.phone}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2  custom-col-4">
                                    <div className="text-right resp-user-info">
                                        <label>
                                            {/*<FormattedMessage id="app.admin-info.role"*/}
                                                              {/*defaultMessage="Role"*/}
                                                              {/*description=""/>*/}
                                            権限
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-4 custom-col-4 no-padding-left ">
                                    {this.state.role}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2  custom-col-4">
                                    <div className="text-right resp-user-info">
                                        <label>
                                            <FormattedMessage id="app.admin-info.username"
                                                              defaultMessage="Username"
                                                              description=""/>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-4 custom-col-4 no-padding-left ">
                                    {this.state.username}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="col-md-2  custom-col-4">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.admin-info.status"
                                                              defaultMessage="Status"
                                                              description=""/>

                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-4 custom-col-4 no-padding-left ">
                                    {/*{this.state.status}*/}
                                    {this.state.status ==='INACTIVE' ? '非アクティブ':''}
                                    {this.state.status ==='ACTIVE' ? 'アクティブ':''}
                                    {this.state.status ==='BLOCKED' ? 'ブロックされた':''}
                                    {this.state.status ==='DELETED' ? '削除された':''}

                                </div>
                            </div>
                        </div>

                        {/*<div className="row">*/}
                            {/*<div className="user-update-row-margin">*/}
                                {/*<div className="col-md-2">*/}
                                    {/*<div className="text-right">*/}
                                        {/*<label>*/}
                                            {/*<FormattedMessage id="app.admin-info.first-name"*/}
                                                              {/*defaultMessage="Japanese First Name"*/}
                                                              {/*description=""/>*/}

                                        {/*</label>*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                                {/*<div className="col-md-4 no-padding-left ">*/}
                                    {/*{this.state.japaneseFirstName}*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        {/*<div className="row">*/}
                            {/*<div className="user-update-row-margin">*/}
                                {/*<div className="col-md-2">*/}
                                    {/*<div className="text-right">*/}
                                        {/*<label>*/}
                                            {/*<FormattedMessage id="app.admin-info.last-name"*/}
                                                              {/*defaultMessage="Japanese Last Name"*/}
                                                              {/*description=""/>*/}

                                        {/*</label>*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                                {/*<div className="col-md-4 no-padding-left ">*/}
                                    {/*{this.state.japaneseLastName}*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        <div className="row">
                            <div className="user-update-row-margin">
                                <div className="pull-right responsive-pull-right">
                                    <Link to={"/admin/users/all"} className="">
                                        <FormattedMessage id="app.admin-info.back"
                                                          defaultMessage="<< Back"
                                                          description=""/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}
export default AdminInformation;



// WEBPACK FOOTER //
// ./src/components/Admin/AdminInformation/AdminInformation.js